// src/pages/finance/payroll/FinancePayrollDashboard.jsx
import React, { useState } from "react";
import Layout from "../../../components/common/Layout";
import { getNavItems, getPanelLabel } from "../../../utils/navigation";
import { useAuth } from "../../../context/AuthContext";
import PayrollSection from "./PayrollSection";
import PayrollSettingsSection from "./PayrollSettingsSection";

export default function FinancePayrollDashboard() {
  const { userProfile } = useAuth();
  const [activeTab, setActiveTab] = useState("payroll"); // "payroll" | "settings"

  const navItems = getNavItems(userProfile);
  const panelLabel = getPanelLabel(userProfile);

  return (
    <Layout navItems={navItems} panelLabel={panelLabel}>
      <div className="admin-dashboard">
        <div className="att-tab-bar" style={{ marginBottom: "1.5rem" }}>
          <button
            className={`att-tab-btn ${activeTab === "payroll" ? "att-tab-btn--active" : ""}`}
            onClick={() => setActiveTab("payroll")}
          >
            Payroll &amp; Compensation
          </button>
          <button
            className={`att-tab-btn ${activeTab === "settings" ? "att-tab-btn--active" : ""}`}
            onClick={() => setActiveTab("settings")}
          >
            Payroll Settings
          </button>
        </div>

        {activeTab === "payroll" && <PayrollSection />}
        {activeTab === "settings" && <PayrollSettingsSection />}
      </div>
    </Layout>
  );
}
